import styled from "styled-components";

export const ReferralContainer = styled("div")`
  svg {
    cursor: pointer;
  }
  .referral-container {
    background-color: var(--white-color);
    width: 90%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const ReferralDetailTableHead = styled("div")`
  background: var(--field-color);
  color: var(--white-color);
  border-radius: var(--border-radius-1);
  padding: 15px 5px;
  display: flex;
  justify-content: start;
  margin-top: 20px;
`;
export const ReferralDetailTableBody = styled("div")`
  width: 100%;
  padding: 20px 5px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  &:nth-child(2n-1) {
    background-color: var(--blue-color-light);
  }
`;
